/*
  Live Trustpilot reviews for the pods "cards without images" theme.

  Progressive enhancement: the section already renders its manually-entered
  blocks server-side. This only replaces them once a fetch succeeds, so a
  failed or slow request simply leaves the authored reviews in place.
*/
(function () {
  var ENDPOINT = 'https://api.giftory.com/experience/api/v1/trustpilot/getFiveStarReviews/';
  var MAX_BODY = 300;
  var STAR_PATH =
    'M12 17.27 5.82 21l1.64-7.03L2 9.24l7.19-.61L12 2l2.81 6.63 7.19.61-5.46 4.73L18.18 21z';

  function el(tag, className) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    return node;
  }

  function buildStars(rating) {
    var wrap = el('span', 'hpc-review-stars');
    wrap.setAttribute('role', 'img');
    wrap.setAttribute('aria-label', rating + ' out of 5 stars');

    for (var i = 0; i < 5; i++) {
      var remaining = rating - i;
      var fill = remaining >= 1 ? 100 : remaining > 0 ? 50 : 0;

      var star = el('span', 'hpc-star');
      star.setAttribute('aria-hidden', 'true');

      var on = el('span', 'hpc-star-on');
      on.style.width = fill + '%';
      star.appendChild(on);

      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('focusable', 'false');
      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', STAR_PATH);
      svg.appendChild(path);
      star.appendChild(svg);

      wrap.appendChild(star);
    }
    return wrap;
  }

  // Mirrors the Liquid markup in pods-carousel-v3.liquid so both paths style
  // identically.
  function buildCard(review, layoutClasses) {
    var card = el('div', 'hpc-slide hpc-slide--review ' + layoutClasses);
    card.setAttribute('data-city-item-name', review.title || '');

    if (review.title) {
      var title = el('span', 'hpc-review-title');
      title.textContent = review.title;
      card.appendChild(title);
    }

    if (review.stars) card.appendChild(buildStars(review.stars));

    if (review.text) {
      var body = el('p', 'hpc-review-body');
      body.textContent = review.text;
      card.appendChild(body);
    }

    var name = review.consumer && review.consumer.name;
    var date = review.formattedCreatedAt;
    if (name || date) {
      var meta = el('span', 'hpc-review-meta');
      if (name) {
        var author = el('span', 'hpc-review-author');
        author.textContent = name;
        meta.appendChild(author);
      }
      if (name && date) {
        var dot = el('span', 'hpc-review-dot');
        dot.setAttribute('aria-hidden', 'true');
        dot.textContent = '•';
        meta.appendChild(dot);
      }
      if (date) {
        var when = el('span', 'hpc-review-date');
        when.textContent = date;
        meta.appendChild(when);
      }
      card.appendChild(meta);
    }

    return card;
  }

  function layoutClassesFrom(track) {
    // Reuse whatever sizing classes the server-rendered cards already carry so
    // grow/grid behaviour stays consistent.
    var sample = track.querySelector('.hpc-slide--review');
    if (!sample) return 'flex-none';
    return Array.from(sample.classList)
      .filter(function (c) {
        return c !== 'hpc-slide' && c !== 'hpc-slide--review';
      })
      .join(' ');
  }

  function hydrate(track) {
    var count = parseInt(track.getAttribute('data-tp-count'), 10) || 6;
    var verifiedFirst = track.getAttribute('data-tp-verified-first') === 'true';

    fetch(ENDPOINT + count)
      .then(function (res) {
        if (!res.ok) throw new Error('Trustpilot request failed: ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var reviews = (data && data.latestFiveStarReviews) || [];

        // Overlong reviews break the 3-line clamp, so drop them rather than
        // render a card that is mostly ellipsis.
        reviews = reviews.filter(function (r) {
          return r.title && (!r.text || r.text.length <= MAX_BODY);
        });

        if (verifiedFirst) {
          reviews = reviews.slice().sort(function (a, b) {
            return (b.isVerified ? 1 : 0) - (a.isVerified ? 1 : 0);
          });
        }

        reviews = reviews.slice(0, count);
        if (!reviews.length) return; // keep the authored blocks

        var layout = layoutClassesFrom(track);
        var frag = document.createDocumentFragment();
        reviews.forEach(function (r) {
          frag.appendChild(buildCard(r, layout));
        });

        track.textContent = '';
        track.appendChild(frag);
        track.setAttribute('data-tp-loaded', '');

        // Liquid sized the carousel to the requested count; filtering may have
        // returned fewer. Drop --fit when the cards now overflow so the track
        // can scroll, and add it when they all fit.
        var fits = reviews.length <= (parseInt(track.getAttribute('data-tp-per-view'), 10) || 0);
        track.classList.toggle('hpc-track--fit', fits);

        // Slide count changed, so let the carousel recalculate.
        window.dispatchEvent(new Event('resize'));
      })
      .catch(function (err) {
        // Authored blocks are already on screen; nothing to undo.
        console.warn('[pods-trustpilot]', err);
      });
  }

  function init() {
    var tracks = document.querySelectorAll('[data-tp-track]:not([data-tp-loaded])');
    for (var i = 0; i < tracks.length; i++) hydrate(tracks[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders the section on setting changes.
  document.addEventListener('shopify:section:load', init);
})();
